import styled, { createGlobalStyle } from "styled-components";
import { GrayColors, TextColorNames } from "@smartsuite/types";

export const RecordsSourceEditorWrapper = styled.div`
  margin-bottom: 22px;
  position: relative;
  z-index: 10;
  .records-source-selector .select-placeholder__value {
    padding-left: 0;
  }
  .records-source-selector_looping .select-placeholder__value {
    padding-left: 0;
  }
  .records-source-selector_looping .select-placeholder__placeholder {
    padding-left: 10px;
  }
  .select-placeholder__arrow {
    padding-top: 0;
    align-items: center;
  }
`;

export const RecordsSourceSelectorInput = styled.div`
  .react-input-group {
    background: white;
  }
`;

export const RecordsSourceMenuList = styled.div`
  min-width: 220px;
  padding: 8px 0;
`;

export const RecordsSourceOption = styled.div`
  &.hide {
    display: none;
  }
`;

export const RecordsSourceOptionLeft = styled.div`
  display: flex;
  align-items: center;
  padding: 0 10px 0 10px;
`;

export const RecordsSourceOptionLeftSelected = styled.div`
  display: flex;
  align-items: center;
  padding: 0 12px 0 15px;
`;

export const RecordsSourceOptionMain = styled.div`
  padding: 8px 0px;
`;

export const RecordsSourceOptionMainNew = styled.div`
  font-weight: 500;
  font-size: 13px;
  line-height: 18px;
  padding: 13px 0 14px;
`;

export const RecordsSourceOptionType = styled.div`
  font-weight: 500;
  font-size: 10px;
  line-height: 15px;
  color: var(--tertiary, ${TextColorNames.tertiary});
`;

export const RecordsSourceOptionName = styled.div`
  color: var(--typo-primary, ${TextColorNames.primary});
  font-weight: 500;
  font-size: 13px;
  line-height: 18px;
`;

export const RecordsSourceOptionApplication = styled.div`
  font-weight: 500;
  font-size: 10px;
  line-height: 15px;
  margin-top: 5px;
  color: var(--tertiary, ${TextColorNames.tertiary});
`;

export const RecordsSourceOptionCreateNew = styled.div`
  display: flex;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
`;

export const RecordsSourceOptionEntity = styled.div`
  padding: 4px 5px;
`;

export const RecordsSourceOptionEntityInner = styled.div`
  display: flex;
  border-radius: 5px;
  transition: background 200ms ease-in;
`;

export const RecordsSourceOptionEntityInnerSelected = styled.div`
  display: flex;
  border-radius: 5px;
`;

export const RecordsSourceOptionCreateNoAction = styled.div`
  padding: 14px 17px 18px;
  font-weight: 500;
  font-size: 13px;
  line-height: 18px;
  color: ${GrayColors["G-4"]};
`;

export const GlobalStyle = createGlobalStyle`
  .records-source-selector-list-items .select-list-items__in {
    padding: 0;
    .records-source-selector-list-items__option {
      border-radius: 0;
      &:hover {
        background-color: transparent;
        color: var(--tertiary, ${TextColorNames.tertiary});
        .option-inner {
          background-color: var(--select-option-highlight-background, var(--G-1, ${GrayColors["G-1"]}));
        }
      }
    }
  }
`;
